module.exports = __webpack_public_path__ + "static/media/Walden-Woods-II-HOABylaws.0c291658.pdf";